module.exports = __webpack_public_path__ + "img/United Nations.6aaa20ea.svg";